<div class="service-area">
  <div class="container mx-auto p-4">
    <div class="header-content mb-6 flex justify-between items-end flex-wrap">
      <div class=" w-full lg:w-8/12">
        <h2 class="title pb-3">Discover Our Services — Stay Connected</h2>
        <p class="subtitle pt-5">
          Stay connected with reliable internet from Cladded Glass Broadband. We pride ourselves in a 99.999% uptime.
        </p>
      </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-7 mt-10">
      <div
        *ngFor="let service of services"
        class="rounded-[16px] overflow-hidden service-item"
      >
        <div
          class="w-full bg-cover bg-center relative h-[288px]"
          [ngStyle]="{ 'background-image': 'url(' + service.image + ')' }"
        >
          <div class="absolute top-0 left-0 w-full p-5">
            <img [src]="service.icon" alt="service" />
          </div>
          <div class="p-5 h-full flex items-end">
            <div class="content">
              <h2>{{ service.title }}</h2>
              <p>
                {{ service.description }} <a href="#" class="pl-2">Read More</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
